<template>
  <div id='' class='gPageBorder' v-loading.body='loading'>

    <el-button type=primary class='gSgLeftBtn' @click='addFirm'>{{$t('app_addfmname')}}</el-button>
  
    <div id='fmData'>
      <el-table
        class='gTopMg'
        @row-click='cellClick'
        :data="tableData"
        @sort-change="sortChange"
        border
        style="width: 100%">
        <el-table-column
          header-align='center'
          align='center'
          prop="name"
          sortable="custom"
          :label="$t('app_name')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="contacts"
          width='130'
          :label="$t('app_contact')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="tel"
          width=''
          :label="$t('app_contactPhone')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="address"
          width='130'
          :label="$t('app_addres')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="operate"
          width='106'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <!-- <el-button type=text @click='editFirm(scope.row)'>{{$t('app_edit')}}</el-button>
            <el-button type=text @click='deleteFirm(scope.row)'>{{$t('app_del')}}</el-button> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
              <el-button type='text' @click='editFirm(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' @click='deleteFirm(scope.row)'><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv">
        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
  #firmMg{border-top:0px solid #8492A6;}
</style>

<script>
  export default{
    data () {
      return {
        orderName: '',
        orderType: '',
        tableData: [{}],
        loading: 0,
        row: this.$gRow,
        total: 0
      }
    },
    computed: {
      index () {
        return this.$getWPage('dataFirmPage')
      }
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'name':
            this.orderName = '1'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList(this.index)
      },
      pageSelect (index) {
        this.getList(index)
        this.$setWPage('dataFirmPage', index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getList(this.index)
      },
      addFirm () {
        this.$setWObj('editDataConfig', {type: 0, pageType: 1})
        //this.$router.push({name: this.$t('menu.dataManageSub.newFirm')})
        // 
        this.$router.push({path: '/firms/newfirm'})
        // this.$router.push({path: '/firms/editfirm'})
      },
      deleteFirm (row) {
        // console.log(row)
        this.$showConfirm('', this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warnning', () => {
          // sure
          this.$deleteFirm(row.manufid, (res) => {
            // console.log(res)
            if (res.status === 200) {
              this.getList(this.index)
            } else {
              this.$message.error(res.message)
            }
          })
        })
      },
      editFirm (row) {
        this.$setWObj('editDataConfig', {type: 1, data: row})
        // this.$router.push({name: this.$t('menu.dataManageSub.editFirm')})
        this.$router.push({path: '/firms/editfirm'})
      },
      getList (index) {
        this.loading = 1
        this.$getFirmList(this.$gRow, index, this.orderName, this.orderType, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.tableData = res.data
            this.index = index
            this.total = res.total
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
        })
      }
    },
    mounted () {
      // this.$cleanWObj()
      this.getList(this.index)
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// firmManage.vue?76d5d3c6